import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { Modal } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { BsExclamationTriangle, BsTablet, BsPlayBtn, BsGear, BsPeople, BsFolder } from 'react-icons/bs'

import CustomButton from '../../component/CustomButton'
import './DeleteCompanyModal.sass'

const CONFIRM_WORD = 'DELETE'

const DeleteCompanyModal = (props) => {
	const { show, onCancel, onConfirm } = props
	const { t } = useTranslation('translation', { keyPrefix: 'companiesPage.deleteCompanyModal' })

	const [confirmText, setConfirmText] = useState('')

	useEffect(() => {
		if (show) {
			setConfirmText('')
		}
	}, [show])

	const canDelete = confirmText === CONFIRM_WORD

	return (
		<Modal
			show={show}
			onHide={onCancel}
			className="delete-company-modal"
		>
			<Modal.Header closeButton>
				<Modal.Title className="delete-title delete-company-modal-title">
					<BsExclamationTriangle />
					{t('title')}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<div className="delete-company-warning">
					<BsExclamationTriangle />
					<div>
						<div className="delete-company-warning-title">{t('warningTitle')}</div>
						<div className="delete-company-warning-text">{t('warningText')}</div>
					</div>
				</div>

				<div className="delete-company-list-title">{t('listTitle')}</div>
				<div className="delete-company-list">
					<div className="delete-company-list-item">
						<BsTablet />
						<span>{t('itemDevices')}</span>
					</div>
					<div className="delete-company-list-item">
						<BsPlayBtn />
						<span>{t('itemData')}</span>
					</div>
					<div className="delete-company-list-item">
						<BsGear />
						<span>{t('itemSettings')}</span>
					</div>
					<div className="delete-company-list-item">
						<BsPeople />
						<span>{t('itemUsers')}</span>
					</div>
					<div className="delete-company-list-item">
						<BsFolder />
						<span>{t('itemGroups')}</span>
					</div>
				</div>

				<div className="delete-company-confirm">
					<label htmlFor="delete-company-confirm-input">
						{t('confirmLabelPrefix')} <strong className="delete-company-confirm-word">{CONFIRM_WORD}</strong> {t('confirmLabelSuffix')}
					</label>
					<input
						id="delete-company-confirm-input"
						type="text"
						className="delete-company-confirm-input"
						placeholder={t('confirmPlaceholder', { confirmWord: CONFIRM_WORD })}
						value={confirmText}
						onChange={(e) => setConfirmText(e.target.value)}
						autoComplete="off"
					/>
				</div>
			</Modal.Body>
			<Modal.Footer bsPrefix="default-modal-footer modal-footer delete-company-modal-footer">
				<CustomButton variant="primary-outline" prefix="rosco-primary-cancel btn btn-default" onClick={onCancel}>{t('btnCancel')}</CustomButton>
				<CustomButton variant="delete" disabled={!canDelete} onClick={onConfirm}>{t('btnDelete')}</CustomButton>
			</Modal.Footer>
		</Modal>
	)
}

DeleteCompanyModal.propTypes = {
	show: PropTypes.bool.isRequired,
	onCancel: PropTypes.func.isRequired,
	onConfirm: PropTypes.func.isRequired,
}

export default DeleteCompanyModal;
